<template>
    <div
        class="flex w-full flex-col gap-4 rounded bg-white p-6 shadow"
        v-if="user.subscription"
    >
        <div class="font-semibold">Your Organization</div>
        <div class="flex items-start justify-between pb-4">
            <div class="">
                {{ $page.props.auth.user.group.name }}
            </div>
            <!--            <div-->
            <!--                class=""-->
            <!--                v-if="$page.props.auth.user.subscription.status === 'expired'"-->
            <!--            >-->
            <!--                <new-modal-->
            <!--                    ref="leaveGroupModal"-->
            <!--                    :title="'Leave' + ' ' + $page.props.auth.user.group.name"-->
            <!--                >-->
            <!--                    <template #trigger>-->
            <!--                        <span-->
            <!--                            class="text-red-400 underline hover:cursor-pointer hover:text-red-500"-->
            <!--                            >Leave Group</span-->
            <!--                        >-->
            <!--                    </template>-->
            <!--                    <template #content-->
            <!--                        >Leaving a group will convert your account into an-->
            <!--                        independent student account, you will be able to manage-->
            <!--                        your own EMTprep subscription. You will need to be-->
            <!--                        re-invited by an instructor if you want to re-join your-->
            <!--                        current group, or join another group.-->
            <!--                    </template>-->
            <!--                    <template #controls>-->
            <!--                        <div class="flex w-full justify-end gap-4">-->
            <!--                            <div-->
            <!--                                @click="cancel"-->
            <!--                                class="rounded border border-gray-325 px-3 py-2 hover:cursor-pointer hover:bg-gray-325"-->
            <!--                            >-->
            <!--                                Cancel-->
            <!--                            </div>-->
            <!--                            <div-->
            <!--                                @click="leaveGroup"-->
            <!--                                class="rounded border border-primary-525 bg-primary-525 px-3 py-2 text-white hover:cursor-pointer"-->
            <!--                            >-->
            <!--                                Leave Group-->
            <!--                            </div>-->
            <!--                        </div>-->
            <!--                    </template>-->
            <!--                </new-modal>-->
            <!--            </div>-->
        </div>
        <div class="" v-if="user.subscription.plan.type === 1">
            <div class="font-semibold">Group Subscription</div>

            <div class="flex items-start justify-between pb-4">
                <div class="">Expiration Date:</div>
                <div class="">
                    <span>
                        {{
                            dayjs(user.subscription.ends_at)
                                .utc(true)
                                .tz($page.props.display_timezone)
                                .format($page.props.date_formats.short_nice)
                        }}
                        <span class="text-gray-625"
                            >(In
                            {{ user.subscription.days_left }}
                            days)</span
                        >
                    </span>
                </div>
            </div>
            <div
                class="flex flex-col items-start justify-end gap-4 pb-4"
                v-if="user.subscription.status === 'expired'"
            >
                <div class="border border-red-400 bg-red-125 p-4">
                    Your membership has expired. To continue using EMTprep your
                    instructor can add additional time to your account or you
                    can sign up for a self-managed subscription.
                    <div class="mt-4 flex justify-end">
                        <Link
                            :href="route('frontend.pricing')"
                            class="rounded bg-primary-525 px-3 py-2 text-white hover:cursor-pointer"
                        >
                            Add Subscription
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import NewModal from "@/Components/NewModal.vue";

export default {
    name: "GroupStudentSubscriptionManageWidget",
    components: { NewModal },
    props: {
        user: {},
    },
    methods: {
        cancel: function () {
            this.$refs.leaveGroupModal.closeModal();
        },
        leaveGroup: function () {
            this.$inertia.post(route("student.account.leave-group"));
        },
    },
};
</script>
